<template>
  <div class="order-form">
    <div class="order-form__wrap" v-show="!isCompleted">
      <base-input
        :label="'Телефон'"
        :after-input="'+7'"
        v-model="$v.form.phone.$model"
        placeholder="(999) 999-99-99"
        v-mask="'(###) ###-##-##'"
      >
        <template v-slot:helperText>
          <span class="order-form__text-error" v-show="$v.form.phone.$error"
            >введите номер телефона</span
          >
        </template>
      </base-input>
      <base-select
        :label="'Город'"
        v-model="city"
        :cities="cityList"
      ></base-select>
      <base-input
        :label="'Адрес доставки'"
        v-model.trim="form.address"
      ></base-input>
      <v-button-switcher
        :items="itemsSwitch"
        :select-item="form.selectFuel"
        @switcher-select="onSwitch"
      />

      <base-input
        :label="'Объем топлива, литры'"
        v-model="$v.form.volume.$model"
        v-mask="'###'"
      >
        <template v-slot:helperText>
          <span class="order-form__text-error" v-show="$v.form.volume.$error"
            >минимальный заказ 20 литров</span
          >
        </template>
      </base-input>

      <div class="order-form__footer" v-if="form.volume && form.selectFuel">
        <div class="order-form__full-price">
          Стоимость: {{ totalCountPrice.toFixed(2) }}
        </div>
        <div class="order-form price-info">
          <div class="price-info-calc">
            <span
              >Топливо: {{ priceFuel.toFixed(2) }} +
              {{ deliveryPrice }} доставка</span
            >
          </div>
          <div class="price-info-description">
            точную стоимость доставки уточняйте у оператора по телефону
          </div>
        </div>
      </div>

      <div class="order-form__btn" v-if="city">
        <base-button :disabled="$v.form.$invalid" @click="createOrder"
          >Заказать
        </base-button>
      </div>
    </div>
    <div class="order-form__wrap-complete" v-show="isCompleted">
      <img src="@/assets/img/modal/icon-complete.svg" alt="" />
      <h2>Ваш заказ принят</h2>
      <p>Наши менеджеры свяжутся с вами для подтверждения и уточнения заказа</p>
      <div class="order-form__btn-second">
        <base-button :type="'secondary'" @click="isCompleted = false"
          >Заказать ещё
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import VButtonSwitcher from "@/components/vButtonSwitcher";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import axios from "axios";
import qs from "qs";
import BaseSelect from "@/components/BaseSelect";

export default {
  name: "OrderForm",
  components: { BaseSelect, VButtonSwitcher },
  props: {
    itemsSwitch: {
      type: Array
    }
  },
  data() {
    return {
      isCompleted: false,
      // itemsSwitch: [],
      fuelPrice: null,
      deliveryPrice: null,
      totalPrice: null,
      cityList: [],
      city: null,
      form: {
        phone: "",
        selectFuel: null,
        volume: "",
        address: ""
      }
    };
  },

  validations: {
    form: {
      phone: {
        required,
        minLength: minLength(15)
      },
      volume: {
        required,
        minValue: minValue(20)
      }
    }
  },
  mounted() {
    this.$v.$reset();
    this.getCities();
  },
  methods: {
    onSwitch(item) {
      this.form.selectFuel = item.id;
      this.fuelPrice = item.price;
      this.deliveryPrice = item.delivery;
    },
    async getCities() {
      let url = new URL(`${process.env.VUE_APP_API_URL}/v1/cities/list`);
      await axios
        .get(url)
        .then(response => {
          this.cityList = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async createOrder() {
      let form = qs.stringify({
        phone: `+7 ${this.form.phone}`,
        fuel_type_id: this.form.selectFuel,
        fuel_volume: this.form.volume,
        city_id: this.city.id,
        address: this.form.address
      });
      if (!this.$v.$error) {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/v1/land-application/create`,
            form
          )
          .then(() => {
            this.form = {
              phone: "",
              selectFuel: null,
              volume: ""
            };
            this.$v.$reset();
            this.isCompleted = true;
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  computed: {
    totalCountPrice() {
      return this.fuelPrice * this.form.volume + 199;
    },
    priceFuel() {
      return this.fuelPrice * this.form.volume;
    }
  }
};
</script>

<style scoped></style>
